import {
	Column as RiskDetailsColumn,
	headerReactNodes as rehabResultHeaderReactNodes,
} from './rehabResultPagination';
import { type FilterStoreState } from '@innovyze/lib-am-common';
import { filterByMultipleIdSelect } from '@innovyze/lib-am-common/Reducers';
import { MEASUREMENT_SYSTEM } from '@Utils/units/unitsMappingValues';
import { t } from 'i18next';

export const rehabResultInitialState = (): FilterStoreState => {
	const headers = rehabResultHeaderReactNodes(MEASUREMENT_SYSTEM.METRIC, t);
	const draftRehabAction = headers[RiskDetailsColumn.DraftRehabAction];
	const finalRehabAction = headers[RiskDetailsColumn.FinalRehabAction];

	return {
		query: '',
		filters: {},
		selects: [
			//Supposely this filter is for final rehab action, but for now draft rehab is easier, we keep the key to be final action
			{
				column: {
					id: finalRehabAction.key,
					caption: draftRehabAction.cell,
				},
				options: [],
				dataCy: finalRehabAction.key,
				filterBy: filterByMultipleIdSelect,
				value: [],
				multiple: true,
			},
		].reduce((d, v) => ({ ...d, [v.column.id]: v }), {}),
	};
};
